var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',[(!_vm.showDetails)?_c('TrailWelcome',{on:{"go":_vm.readyToGo}}):_c('TrailPicker',{attrs:{"slug":_vm.slug}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }